module.exports = __webpack_public_path__ + "fonts/Inter-ThinItalic.98a9e6d.woff";